<template>
  <div class="d-inline-flex">
    <base-button
      @click="showImportModal"
      class="notification mr-2"
      type="info"
      icon
      size="sm"
    >
      <span class="btn-inner--icon">
        <i class="fa fa-cloud-download"></i>
      </span>
    </base-button>
    <modal
      :show="showModal"
      modal-classes="modal-secondary"
    >
      <div class="content-btns-modal">
        <div class="modal-header">
        <button
            type="button"
            class="btn btn-link ml-auto"
            @click="closeImportModal"
          >
            <i class="fa fa-times"></i>
          </button>
        </div>
        <a download class="btn-link" href="/models/proprietes.xlsx">
          <i class="fa fa-download"></i>
          {{ $t("PROPERTIES.IMPORT_MODEL_FILE") }}
        </a>
        <base-button
          @click="$refs.fieldsFileInput.click()"
          class="elite-button add"
          type="info"
          icon
          size="sm"
        >
          <span class="btn-inner--icon">
            <i class="fa fa-cloud-download"></i>
            {{ $t("PROPERTIES.IMPORT_FILE") }}
          </span>
          <input
            style="display: none"
            type="file"
            id="property-file-input"
            ref="fieldsFileInput"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            @change="importProperties"
          />
        </base-button>
      </div>
    </modal>
    <modal
      :show="showResultsModal"
      modal-classes="modal-secondary"
      size="xl"
    >
      <div>
        
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h2 class="mb-0">
            {{
              $t("PROPERTIES.IMPORT_PREVIEW")
            }}
          </h2>
          <base-button
            :disabled="isDry"
            @click="checkContactAddress"
            type="button"
            class="btn btn-sm btn-primary text-uppercase px-3"
            style="width: auto"
          >
            {{ $t("PROPERTIES.FINALIZE_IMPORT") }}
          </base-button>
        </div>
        <div v-if="showResultsModal">
          <el-table
            :data="synchronisationResult"
            style="width: 100%"
            type="expand"
            row-key="id"
          >
            <el-table-column
              prop="line"
              :label="$t('PROPERTIES.FIELDS_CREATED')"
            >
              <template v-slot="{ row }">
                {{ `${row.propertiesAdded}` }}
              </template>
            </el-table-column>
            <el-table-column
              prop="line"
              :label="$t('PROPERTIES.FIELDS_UPDATED')"
            >
              <template v-slot="{ row }">
                {{ `${row.propertiesUpdated}` }}
              </template>
            </el-table-column>
            <el-table-column
              prop="line"
              :label="$t('PROPERTIES.CONTACTS_CREATED')"
            >
              <template v-slot="{ row }">
                {{ `${row.contactsAdded}` }}
              </template>
            </el-table-column>
            <el-table-column
              prop="line"
              :label="$t('PROPERTIES.CONTACTS_UPDATED')"
            >
              <template v-slot="{ row }">
                {{ `${row.contactsUpdated}` }}
              </template>
            </el-table-column>
            <el-table-column
              prop="line"
              :label="$t('PROPERTIES.FIELDS_ERRORS')"
            >
              <template v-slot="{ row }">
                {{ `${row.errors.length}` }}
              </template>
            </el-table-column>

            <el-table-column type="expand">
              <template slot-scope="props">
                <el-table
                  :data="props.row.errors"
                  style="width: 100%"
                  type="expand"
                  row-key="id"
                >
                  <el-table-column
                    prop="id"
                    :label="$t('PROPERTIES.DETAIL')"
                  >
                    <template v-slot="{ row }">
                      {{ `${row.name}` }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    :label="$t('PROPERTIES.ERROR')"
                  >
                    <template v-slot="{ row }">
                      <span class="text-danger">{{ row.error }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            layout="prev, pager, next"
            :total="synchronisationResult.length"
          ></el-pagination>
          <button
            type="button"
            class="btn btn-link ml-auto"
            @click="closeImportModal"
          >
            {{ $t("COMMON.CLOSE") }}
          </button>
        </div>
      </div>
    </modal>
    <modal :show="showContactDefaultAddressModal" modal-classes="modal-secondary" size="lg">
      <div class="" slot="header">
        <h2 id="confirmation">
          {{ $t("CONTACTS.ADDRESS_CONFIRMATION") }}
        </h2>
      </div>
      <div class="">
        <div class="row">
          <el-card
                v-if="contactsIncorrectAddress > 0"
                class="box-card mb-3"
                shadow="never"
                :body-style="{ color: '#E6A23C', background: '#fdf6ec' }"
              >
              <div class="font-weight-bold mb-4">IMPORTANT !</div>
              <div class="text-xs mb-3">
                {{ contactsIncorrectAddress == 1 ? $t("CONTACTS.ONE_INCORRECT_ADDRESS_MESSAGE") : contactsIncorrectAddress+$t("CONTACTS.INCORRECT_ADDRESS_MESSAGE") }}
              </div>
            </el-card>
        </div>
        <div class="row">
          <p class="text-lg text-center">
            {{ contactsEmtyAddress == 1 ? $t("CONTACTS.NO_ONE_ADDRESS_MESSAGE") : contactsEmtyAddress+$t("CONTACTS.NO_MULTIPLE_ADDRESS_MESSAGE") }}
          </p>
        </div>
        <div class="py-1">
          <dl class="row">
            <dt class="col-sm-4 text-left">{{ $t("COMMON.ADDRESS") }}</dt>
            <dd class="col-sm-8 text-left">
              <div v-html="defaultAddressInformation.address"></div>
            </dd>
          </dl>

          <dl class="row">
            <dt class="col-sm-4 text-left">{{ $t("COMMON.CITY") }}</dt>
            <dd class="col-sm-8 text-left">
              <div v-html="defaultAddressInformation.city"></div>
            </dd>
          </dl>

          <dl class="row">
            <dt class="col-sm-4 text-left">{{ $t("COMMON.ZIPCODE") }}</dt>
            <dd class="col-sm-8 text-left">
              <div v-html="defaultAddressInformation.zipcode"></div>
            </dd>
          </dl>

          <dl class="row">
            <dt class="col-sm-4 text-left">{{ $t("COMMON.STATE") }}</dt>
            <dd class="col-sm-8 text-left">
              <div v-html="defaultAddressInformation.state"></div>
            </dd>
          </dl>

          <dl class="row">
            <dt class="col-sm-4 text-left">{{ $t("COMMON.COUNTRY") }}</dt>
            <dd class="col-sm-8 text-left">
              <div v-html="defaultAddressInformation.country"></div>
            </dd>
          </dl>
        </div>
      </div>
      <template slot="footer">
        <button
          type="button"
          class="btn btn-link close"
          @click="toggleModalState"
          :disabled="loading"
        >
          {{ $t("COMMON.CANCEL") }}
        </button>

        <button
          type="submit"
          :disabled="loading"
          class="btn btn-warning ml-auto mr--5"
          @click="continueProcessWithoutAddress"
        >
          <span v-if="loading" class="btn-inner--icon">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
          {{ $t("CONTACTS.WITHOUT_ADDRESS") }}
        </button>

        <button
          type="submit"
          class="btn btn-primary add ml-auto"
          @click="continueProcess"
          :disabled="loading"
        >
          <span v-if="loading" class="btn-inner--icon">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
          {{ $t("CONTACTS.USE_DEFAULT_ADDRESS") }}
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
import swal from "sweetalert2";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
  Pagination,
} from "element-ui";
import formMixin from "@/mixins/form-mixin";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { defaultAddressInformation } from "@/constants/defaultAddressInformation";
import { Card } from "element-ui";

export default {
  name: "import-properties-component",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    [Pagination.name]: Pagination,
    [Card.name]: Card,
  },

  mixins: [formMixin, requestErrorMixin],

  props: ["inspectionForm"],

  data() {
    return {
      showFileModal: false,
      showResultsModal: false,
      isDry: true,
      synchronisationResult: [],
      fieldsFile: null,
      file: null,
      showModal: false,
      contactsEmtyAddress: 0,
      contactsIncorrectAddress: 0,
      useDefaultAddess: false,
      showContactDefaultAddressModal: false,
      defaultAddressInformation,
      loading: false,
      acceptContactIncorrectAddress: false,
    };
  },

  created() {},

  methods: {
    showImportModal(){
      this.showModal = true;
    },
    closeImportModal(){
      this.showModal = false;
      this.showResultsModal = false;
    },
    async importProperties(e) {
      const file = e.target.files[0];
      this.file = file;
      if (!file) {
        return;
      }
      e.target.value = "";
      swal.fire({
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading();
        },
      });
      try {
        await this.$store.dispatch("files/upload", {
          image: file,
          ressource_name: "properties",
          ressource_id: "200",
          field: "files",
        });
        this.fieldsFile = await this.$store.getters["files/url"];

        const results = await this.$store.dispatch(
          "properties/importProperties",
          {
            file: this.fieldsFile,
            dry: this.isDry,
            useDefaultAddess: this.useDefaultAddess,
          }
        );
        this.synchronisationResult = [results];
        this.isDry = results.errors.length > 0;
        this.contactsEmtyAddress = results.contactEmtyAddress;
        this.contactsIncorrectAddress = results.contactIncorrectAddress;
        this.showModal = false;
        this.showResultsModal = true;
      } catch (error) {
        console.log(error);
        await this.showRequestError(error);
      }
      swal.close();
    },
    toggleModalState(){
      this.showContactDefaultAddressModal = false;
      this.closeImportModal();
    },
    async continueProcess(){
      this.useDefaultAddess = true;
      if(this.contactsIncorrectAddress > 0 && !this.acceptContactIncorrectAddress){
        let modamTitle = this.contactsIncorrectAddress == 1 ? this.$t("CONTACTS.ONE_ADDRESS_INCORRECT") : this.$t("CONTACTS.ADDRESS_INCORRECT")+this.contactsIncorrectAddress;
        const confirmation = await swal.fire({
          title: modamTitle,
          html: '<p>'+this.$t("CONTACTS.ADDRESS_INCORRECT_CONFIRMATION")+'</p>',
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: this.$t("COMMON.YES"),
          cancelButtonText: this.$t("COMMON.NO"),
          confirmButtonClass: "btn btn-primary",
          cancelButtonClass: "btn btn-warning",
        });

        try {
          if (confirmation.value === true) {
            this.acceptContactIncorrectAddress = true;
            this.showContactDefaultAddressModal = false;
            this.runSync();
          }
        } catch (error) {
          await this.showRequestError(error);
          this.$notify({
            type: "danger",
            message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
          });
        }
      }else{
        this.showContactDefaultAddressModal = false;
        this.runSync();
      }
    },
    async continueProcessWithoutAddress(){
      this.useDefaultAddess = false;
      if(this.contactsIncorrectAddress > 0 && !this.acceptContactIncorrectAddress){
        let modamTitle = this.contactsIncorrectAddress == 1 ? this.$t("CONTACTS.ONE_ADDRESS_INCORRECT") : this.$t("CONTACTS.ADDRESS_INCORRECT")+this.contactsIncorrectAddress;
        const confirmation = await swal.fire({
          title: modamTitle,
          html: '<p>'+this.$t("CONTACTS.ADDRESS_INCORRECT_CONFIRMATION")+'</p>',
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: this.$t("COMMON.YES"),
          cancelButtonText: this.$t("COMMON.NO"),
          confirmButtonClass: "btn btn-primary",
          cancelButtonClass: "btn btn-warning",
        });

        try {
          if (confirmation.value === true) {
            this.acceptContactIncorrectAddress = true;
            this.showContactDefaultAddressModal = false;
            this.runSync();
          }
        } catch (error) {
          await this.showRequestError(error);
          this.$notify({
            type: "danger",
            message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
          });
        }
      }else{
        this.runSync();
      }
      this.showContactDefaultAddressModal = false;
      
    },
    async checkContactAddress(){
      if(this.contactsEmtyAddress > 0){
        this.showContactDefaultAddressModal = true;
      }else if(this.contactsIncorrectAddress > 0 && this.contactsEmtyAddress == 0){
        let modamTitle = this.contactsIncorrectAddress == 1 ? this.$t("CONTACTS.ONE_ADDRESS_INCORRECT") : this.$t("CONTACTS.ADDRESS_INCORRECT")+this.contactsIncorrectAddress;
          const confirmation = await swal.fire({
            title: modamTitle,
            html: '<p>'+this.$t("CONTACTS.ADDRESS_INCORRECT_CONFIRMATION")+'</p>',
            type: "question",
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: this.$t("COMMON.YES"),
            cancelButtonText: this.$t("COMMON.NO"),
            confirmButtonClass: "btn btn-primary",
            cancelButtonClass: "btn btn-warning",
          });

          try {
            if (confirmation.value === true) {
              this.acceptContactIncorrectAddress = true;
              this.showContactDefaultAddressModal = false;
              this.runSync();
            }
          } catch (error) {
            await this.showRequestError(error);
            this.$notify({
              type: "danger",
              message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
            });
          }
      }else{
        this.runSync();
      }
    },

    async runSync() {
      this.isDry = false;
      swal.fire({
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading();
        },
      });
      try {
        await this.$store.dispatch("files/upload", {
          image: this.file,
          ressource_name: "properties",
          ressource_id: "200",
          field: "files",
        });
        this.fieldsFile = await this.$store.getters["files/url"];

        const results = await this.$store.dispatch(
          "properties/importProperties",
          {
            file: this.fieldsFile,
            dry: this.isDry,
            useDefaultAddess: this.useDefaultAddess,
          }
        );
        this.$emit("syncSuccess");
        this.showResultsModal = false;
        this.$notify({
          type: "success",
          message: this.$t("PROPERTIES.FILE_IMPORTED"),
        });
      } catch (error) {
        console.log(error);
        await this.showRequestError(error);
      }
      swal.close();
    },
  },
};
</script>
<style lang="scss" scoped>
  .content-btns-modal{
    text-align: center !important;
  }
  .content-btns-modal a{
    margin-right: 20px;
  }
  .modal-header{
    margin-right: -50px;
    margin-bottom: -30px;
  }
  .el-card{
    width: 100%;
    text-align: left;
  }
</style>